// extracted by mini-css-extract-plugin
export default {"root":"styles_root__bGYSV","trashWrapper":"styles_trashWrapper__rhtA1","trash":"styles_trash__EAbSi"};